export default {
	getById(id, cb, ecb, config) {
		this.http
			.get(`/feedback/getById/${id}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	search(params, cb, ecb) {
		this.http
			.get('/feedback/search', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	searchReply(params, cb, ecb) {
		this.http
			.get('/feedback/searchReply', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	add(form, cb, ecb, config) {
		this.http
			.post('/feedback/add/', form, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	reply(form, cb, ecb, config) {
		this.http
			.post('/feedback/reply/', form, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	status(id, to, cb, ecb, config) {
		this.http
			.get(`/feedback/status/${id}/${to}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	remove(id, cb, ecb, config) {
		this.status(id, 'delete', cb, ecb, config)
	}
}
